/* global translate navigator, RTCSessionDescription, RTCIceCandidate, RTCPeerConnection */
import { connect } from 'react-redux'
import * as Jsx from './rxCall.jsx'
import { initializeApp } from "firebase/app"
import { getDatabase, ref, set } from "firebase/database"
const getStats = require('getstats')

// const { rxsetLocal, rxgetLocal } = global.rootRequire('classes/request')
const RxComponent = global.rootRequire('components/shares/rxComponent').default
const { rxaget, secondsToTime, isElectron } = global.rootRequire('classes/ulti')

const { netaCallHistoryUpdate, changeStatusTabmore, changeGroupFunc } = global.rootRequire('redux')
const rxio = global.rootRequire('classes/socket').default

const chatDB = global.rootRequire('classes/indexedDB').default

//const iceServers = {
//  iceServers: [{
//    urls: ['turn:turn.hura.asia:3478'],
//    username: 'developer',
//    credential: 'password'
//  }, {
//    urls: ['stun:turn.hura.asia:3478'],
//    username: 'developer',
//    credential: 'password'
//  }]
//}

const iceServers = {
  iceServers: [{
    urls: ['turn:turn.bobacu.io:3478'],
    username: 'turnuser',
    credential: 'turn456'
  }],
  iceTransportPolicy: "relay"
}

//const iceServers = [
//	{ urls: "stun:stun.l.google.com:19302" },
//	{ urls: "stun:stun.l.google.com:5349" },
//	{ urls: "stun:stun1.l.google.com:3478" },
//	{ urls: "stun:stun1.l.google.com:5349" },
//	{ urls: "stun:stun2.l.google.com:19302" },
//	{ urls: "stun:stun2.l.google.com:5349" },
//	{ urls: "stun:stun3.l.google.com:3478" },
//	{ urls: "stun:stun3.l.google.com:5349" },
//	{ urls: "stun:stun4.l.google.com:19302" },
//	{ urls: "stun:stun4.l.google.com:5349" }
//];

let mediaConstraints = {
  audio: true,
  video: true,
}

let flagCall = 0

class CallComponent_ extends RxComponent {
  constructor(props, context) {
    super(props, context, Jsx)
    this.state = {
      group: rxaget(this.props, 'group', {}),

      flagCalling: false,
      ringtone: false,
      flagStartCall: false,
      isStarted: false,
      flagMic: true,
      flagCamera: false,
      flagMinimize: false,
      flagMouseOver: false,
      flagShowDebug: false,
      flagShareScreen: false,
      seconds: 0,
      time: { h: '00', m: '00', s: '00' },
      remoteStream: {},
      localStream: {},

      audioinput: [],
      audiooutput: [],
      videoinput: [],
      audioinputDefault: '',
      audiooutputDefault: '',
      videoinputDefault: '',
      descAlertCall: 0, //0: Contacting, 1: Ringing, 2: Is Calling, 3: Connecting
      flagShowSetting: false,
      flagEnding: false,
      isRecording: false,
      showSaveRecording: false

    }

    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.users = rxaget(this.props, 'user.users', {}) || {}
    this.type = rxaget(this.props, 'type', '')

    this.localStream = null
    this.remoteStream = null
    this.shareScreenStream = null
    this.rtcPeerConnection = null
    this.timer = null
    this.timeoutCounter = null
    this.secondsCounter = 0
    
    this.mediaRecorder = null
    this.recordedBlobs = []
    this.recordedVideo = null
    this.hasRecording = false

    this.isRoomCreator = false

    this.callObj = {}
    this.rateObj = {}

    this.calleeUser = {}

    this.setRemoteStream = this.setRemoteStream.bind(this)
    this.sendIceCandidate = this.sendIceCandidate.bind(this)
    this.sendConnected = this.sendConnected.bind(this)

    this.gotDevices = this.gotDevices.bind(this)
    this.changeDeviceAudioOutput = this.changeDeviceAudioOutput.bind(this)
    this.changeDeviceAudioInput = this.changeDeviceAudioInput.bind(this)

    try {
      console.log('Init GetDevice ------')
      navigator.mediaDevices.enumerateDevices().then(this.gotDevices).catch((error) => {
        console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
      })
    } catch (e) { }

  }

  componentDidMount() {
    this.loadHandleSocket()
  }

  componentDidUpdate(prevProps, prevState) {
    if ((rxaget(this.props, 'netaCall.status', '') !== rxaget(prevProps, 'netaCall.status', '')) && ['voicecall', 'videocall'].indexOf(rxaget(this.props, 'netaCall.type_call', '')) !== -1) {
      let typecall = (rxaget(this.props, 'netaCall.type_call', '') === 'videocall') ? 2 : 1
      let grouptmp = rxaget(this.props, 'netaCall.payload', {})
      if (isElectron()) {
        window.ipcRenderer.send('data_call', {
          typecall: typecall,
          grouptmp: grouptmp
        })
      } else {
        this.onClickStartCall(typecall, grouptmp)
      }
    }
  }

  loadHandleSocket() {
    rxio.getWaitConnect((data) => {
      if (rxio.connected) {
        if (!isElectron()) {
          rxio.socket.on('event', async (data) => {
            if (data.type === 4) {
              this.setState({ descAlertCall: 1 })
            }
            if (data.type === 5) {
              if (this.state.flagStartCall && this.callObj && this.callObj.media_type && this.callObj.media_type === 1) {
                await this.changeDevice()
                this.setState({ flagCamera: true }, () => {
                  if (this.state.flagStartCall && this.callObj && this.callObj.media_type) {
                    const receiverUin = (this.userid.toString() === rxaget(data, 'sender_uin', "")) ? rxaget(data, 'receiver_uin', "") : this.userid.toString()
                    rxio.socket.emit('event', {
                      group_id: rxaget(data, 'group_id', ''),
                      sender_uin: this.userid,
                      receiver_uin: Number(receiverUin),
                      type: 7
                    }, (data1) => { })
                  }
                })
              }
            }

            if (data.type === 7) {
              if (this.state.flagStartCall && this.callObj && this.callObj.media_type && this.callObj.media_type === 1) {
                const receiverUin = (this.userid.toString() === rxaget(data, 'sender_uin', "")) ? rxaget(data, 'receiver_uin', "") : this.userid.toString()
                rxio.socket.emit('event', {
                  group_id: rxaget(data, 'group_id', ''),
                  sender_uin: this.userid,
                  receiver_uin: Number(receiverUin),
                  type: 7
                }, (data1) => { })

                await this.changeDevice()
              }
            }

            if (data.type === 8) {
              rxio.sendCallAvailableAnswer({
                group_id: rxaget(data, 'group_id', ""),
                sender_uid: rxaget(data, 'sender_uin', ""),
                receiver_uin: rxaget(data, 'receiver_uin', ""),
                type: 2
              })
            }

            if (data.type === 9) {
            }

            if (data.type === 10) {
              // if (this.call_id) {
              //   rxio.socket.emit('call_status', { group_id: data.group_id, call_id: this.call_id }, (data) => {
              //     if (data.status === 1 && data.result === 0) {
              //       this.setState({ call_answer: true })
              //       const receiverUin = global.rxu.get(global.rxu.array(this.state.objsCalling.callee_uins).filter(ele => (ele !== this.userid)), [0])
              //       rxio.socket.emit('event', {
              //         group_id: data.group_id,
              //         sender_uin: this.userid.toString(),
              //         receiver_uin: receiverUin,
              //         type: 4,
              //         data: ''
              //       }, (data1) => {})
              //       rxio.socket.emit('event', {
              //         group_id: data.group_id,
              //         sender_uin: this.userid.toString(),
              //         receiver_uin: receiverUin,
              //         type: 8,
              //         data: ''
              //       }, (data2) => {})
              //     }
              //   })
              // }
            }
          })

          rxio.socket.on('message', (data) => {
            if (this.callObj && this.callObj.call_id && data.attachments.indexOf(this.callObj.call_id) !== -1) {
              this.stopStream()
            }
          })

          // Nhận offer
          rxio.socket.on('ice_sdp', async (event) => {
            // console.log('Socket event callback: offer')
            try {
              if (this.state.flagStartCall) {
                if (event.sdp) {
                  if (!this.isRoomCreator) {
                    this.rtcPeerConnection = new RTCPeerConnection(iceServers)


                    var repeatInterval = 2000; // 2000 ms == 2 seconds
                    getStats(this.rtcPeerConnection, (result) => {
                      this.previewGetStatsResult(this.rtcPeerConnection, result)
                    }, repeatInterval);


                    this.addLocalTracks(this.rtcPeerConnection)
                    this.rtcPeerConnection.ontrack = this.setRemoteStream
                    this.rtcPeerConnection.onicecandidate = this.sendIceCandidate
                    this.rtcPeerConnection.onconnectionstatechange = this.sendConnected
                    this.rtcPeerConnection.oniceconnectionstatechange = (ev) => {
                      if (this.rtcPeerConnection.iceConnectionState === 'failed' && flagCall < 5) {
                        flagCall += 1
                        this.rtcPeerConnection.restartIce()
                      }
                    }
                    this.rtcPeerConnection.setRemoteDescription(new RTCSessionDescription({ type: 'offer', sdp: event.sdp }))

                    this.rtcPeerConnection.onaddstream = function (e) {
                      if (this.remoteAudioComponent) {
                        this.remoteAudioComponent.srcObject = e.stream
                        this.remoteStream = e.stream
                      } else {
                        try {
                          this.remoteAudioComponent = document.getElementById('remote-audio')
                          this.remoteAudioComponent.srcObject = e.stream
                          this.remoteStream = e.stream
                        } catch (e3) { }
                      }
                    }

                    await this.createAnswer(this.rtcPeerConnection)
                  } else {
                    if (this.rtcPeerConnection) {
                      this.rtcPeerConnection.setRemoteDescription(new RTCSessionDescription({ type: 'answer', sdp: event.sdp }))
                    }
                  }
                }
              } else {
                this.stopStream()
              }

            } catch (e) { }
          })

          // Nhận answer
          rxio.socket.on('answer_call', (event) => {
            // console.log('Socket event callback: webrtc_answer')
            try {
              this.setState({ isStarted: true, ringtone: false, flagStartCall: true }, async () => {
                if (this.isRoomCreator) {
                  this.rtcPeerConnection = new RTCPeerConnection(iceServers)

                  var repeatInterval = 2000; // 2000 ms == 2 seconds
                  getStats(this.rtcPeerConnection, (result) => {
                    this.previewGetStatsResult(this.rtcPeerConnection, result)
                  }, repeatInterval);


                  this.addLocalTracks(this.rtcPeerConnection)
                  this.rtcPeerConnection.ontrack = this.setRemoteStream
                  this.rtcPeerConnection.onicecandidate = this.sendIceCandidate
                  this.rtcPeerConnection.onconnectionstatechange = this.sendConnected

                  await this.createOffer(this.rtcPeerConnection)
                  this.startTimer()
                }
              })
            } catch (e) { }
          })

          // Nhận stop call
          rxio.socket.on('stop_call', (event) => {
            this.stopStream()
          })

          // Nhan Candidate
          rxio.socket.on('ice_candidate', (event) => {
            // console.log('Socket event callback: webrtc_ice_candidate')
            // ICE candidate configuration.
            if (this.state.flagStartCall) {
              try {
                var candidate = new RTCIceCandidate({
                  sdpMid: event.sdp_mid,
                  sdpMLineIndex: event.sdp_mline_index,
                  candidate: event.candidate,
                })
                if (this.rtcPeerConnection) {
                  this.rtcPeerConnection.addIceCandidate(candidate)
                }
              } catch (e) { }
            } else {
              this.stopStream()
            }
          })
        }

        // Nhận cuộc gọi
        rxio.socket.on('start_call', async (data) => {
          if (data && data.call && data.call && data.call.started_at && !isNaN(data.call.started_at) && data.call.group_id) {

            try {
              console.log('Init GetDevice When Receive Call ------')
              navigator.mediaDevices.enumerateDevices().then(this.gotDevices).catch((error) => {
                console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
              })
            } catch (e) { }


            chatDB.groups.get({ group_id: data.call.group_id }).then(groupInDB => {
              if (groupInDB) {
                let timestamp = Number(data.call.started_at) * 1000000
                let last_sort = '1' + groupInDB.flagDraf + groupInDB.flagPin + timestamp
                chatDB.groups.update(rxaget(data.call, 'group_id', '').toString(), { last_sort: last_sort, last_sort_call: last_sort, timestamp_call: timestamp }).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => { })
              }
            })
          }
          if (isElectron()) {
            window.ipcRenderer.send('start_call', data)
          } else {
            if (!this.state.flagCalling) {
              // Load local Stream First
              try {
                this.callObj = rxaget(data, 'call', {})
                this.rateObj = rxaget(data, 'call', {})

                if (this.callObj.callee_uins && this.callObj.callee_uins.constructor === Array && this.callObj.callee_uins.length > 1) {
                  let partner_id = this.callObj.callee_uins.filter(uin => uin.toString() !== this.userid.toString())[0]
                  chatDB.users.get(Number(partner_id)).then(uCallee => {
                    if (uCallee) {
                      this.calleeUser = uCallee

                      let uCalleeName = (uCallee.full_name) ? uCallee.full_name : uCallee.phone || ''

                      if (window.Notification && Notification.permission !== "denied" && partner_id) {
                        let notification = new Notification(uCalleeName, {
                          body: uCalleeName + ': ' + translate('Call Ended').toLowerCase(),
                          // body: uCalleeName + ': '+ translate('Contacting...').toLowerCase(),

                          icon: global.rxu.config.cdn_endpoint + uCallee.profile_url,
                          data: {}
                        });
                        notification.onclick = () => {
                          window.focus()
                        }
                      }

                      this.setState({ flagCalling: true, ringtone: true, descAlertCall: 2 }, async () => {
                        this.localVideoComponent = document.getElementById('local-video')
                        this.remoteVideoComponent = document.getElementById('remote-video')

                        this.localAudioComponent = document.getElementById('local-audio')
                        this.remoteAudioComponent = document.getElementById('remote-audio')

                        rxio.socket.emit('event', {
                          type: 4,
                          sender_uin: this.userid.toString(),
                          receiver_uin: partner_id.toString(),
                          data: '',
                          group_id: data.call.group_id.toString(),
                          call_id: data.call.call_id.toString()
                        }, (data1) => {
                          console.log(data1)
                        })

                        rxio.socket.emit('event', {
                          type: 8,
                          sender_uin: this.userid.toString(),
                          receiver_uin: partner_id.toString(),
                          data: '',
                          group_id: data.call.group_id.toString(),
                          call_id: data.call.call_id.toString()
                        }, (data1) => {
                          console.log(data1)
                        })

                        await this.setLocalStream(mediaConstraints, this.callObj.media_type)
                      })
                    }
                  })
                }
              } catch (e) { }
            }
          }
        })
      } else {
        setTimeout(() => {
          this.loadHandleSocket()
        }, 300)
      }
    })
  }

  // Replace Track
  async changeDevice() {
    try {
      try {
        if (this.localStream) {
          const tracks = this.localStream.getTracks()
          tracks.forEach(function (track) { track.stop() })
          this.localStream = null
        }
      } catch (e) { }

      navigator.mediaDevices.getUserMedia({ audio: true, video: true })
        .then(async (stream) => {
          const tracks = stream.getTracks()
          let videoTrack = stream.getVideoTracks()[0];
          this.rtcPeerConnection.getSenders()
            .forEach(async (sender) => {
              if (sender && sender.track) {
                const newTrack = tracks.find(track => track.kind === sender.track.kind)
                this.rtcPeerConnection.removeTrack(sender)

                try {
                  this.localStream = stream
                  this.localVideoComponent.srcObject = stream
                } catch (e) { }
                const newSender = this.rtcPeerConnection.addTrack(videoTrack, stream)
              }
            })
        })
    } catch (e2) { }
  }

  // Gọi đi
  async onClickStartCall(type, grouptmp) {

    try {
      console.log('Init GetDevice When Start Call ------')
      navigator.mediaDevices.enumerateDevices().then(this.gotDevices).catch((error) => {
        console.log('navigator.MediaDevices.getUserMedia error: ', error.message, error.name);
      })
    } catch (e) { }

    type = type || 2
    this.isRoomCreator = true
    let arrUser = rxaget(grouptmp, 'occupants_uins', [])
    if (arrUser.length === 2) {
      let remoteUser = arrUser.filter(uid => uid !== this.userid)[0]

      if (remoteUser !== '' && remoteUser !== this.userid) {
        let ele = grouptmp || {}
        ele.callee_uins = arrUser.filter(uid => uid.toString() !== this.userid.toString())
        ele.caller_uin = this.userid
        ele.media_type = type

        rxio.createCall(ele, (data) => {
          // Load local Stream First
          this.callObj = rxaget(data, 'call', {})
          this.rateObj = rxaget(data, 'call', {})

          if (this.callObj && this.callObj.started_at) {
            chatDB.groups.get({ group_id: this.callObj.group_id }).then(groupInDB => {
              if (groupInDB) {
                let last_sort = '1' + groupInDB.flagDraf + groupInDB.flagPin + Number(this.callObj.started_at) * 1000000

                chatDB.groups.update(rxaget(this.callObj, 'group_id', '').toString(), { last_sort: last_sort }).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => { })
              }
            })
          }
          if (this.callObj.callee_uins && this.callObj.callee_uins.constructor === Array && this.callObj.callee_uins.length > 1) {
            let partner_id = this.callObj.callee_uins.filter(uin => uin.toString() !== this.userid.toString())[0]
            chatDB.users.get(Number(partner_id)).then(uCallee => {
              if (uCallee) {
                this.calleeUser = uCallee

                this.setState({ flagCalling: true, ringtone: true }, async () => {
                  this.localVideoComponent = document.getElementById('local-video')
                  this.remoteVideoComponent = document.getElementById('remote-video')

                  this.localAudioComponent = document.getElementById('local-audio')
                  this.remoteAudioComponent = document.getElementById('remote-audio')

                  await this.setLocalStream(mediaConstraints, this.callObj.media_type)


                  this.startTimeoutCounter()

                  // setTimeout(() => { if (!this.state.isStarted) { this.onClickStopCall() } }, 30000)
                })
              }
            })
          }
        })

      } else {
        console.log('Remote user not exist')
      }
    }
  }

  // Chấp nhận cuộc gọi
  acceptCall() {
    if (this.callObj && this.callObj.callee_uins && this.callObj.callee_uins.constructor === Array && this.callObj.callee_uins.length === 2) {
      rxio.socket.emit('answer_call', {
        group_id: rxaget(this.callObj, 'group_id', ''),
        call_id: rxaget(this.callObj, 'call_id', ''),
        callee_uin: this.userid.toString(),
        answer: 1
      }, () => { })

      this.setState({ ringtone: false, flagStartCall: true, isStarted: true }, () => {
        this.startTimer()
      })
    }
  }

  stopStream() {
    this.stoppedCallObj = { ...this.callObj }
    try {
      clearInterval(this.timer)
      this.timer = null
    } catch (e) { }

    // Stop recording if it's in progress
    if (this.state.isRecording) {
      this.stopRecording()
    }
    
    // Ensure track monitor is cleaned up
    this.clearStreamChangeListeners()

    try {
      if (this.localStream) {
        const tracks = this.localStream.getTracks()
        tracks.forEach(function (track) { track.stop() })
        this.localStream = null
      }
    } catch (e) { }

    try {
      if (this.remoteStream) {
        const remotetracks = this.remoteStream.getTracks()
        remotetracks.forEach(function (track) { track.stop() })
        this.remoteStream = null
      }
    } catch (e) { }

    try {
      if (this.shareScreenStream) {
        const screenTrack = this.shareScreenStream.getVideoTracks()[0]
        if (screenTrack) {
          screenTrack.stop()
        }
      }
    } catch (e) { }

    if (this.rtcPeerConnection) {
      this.rtcPeerConnection.close()
      this.rtcPeerConnection = null
      // this.openCallRating(true)
    }

    this.isRoomCreator = false
    this.callObj = {}

    this.stopTimeoutCounter()
    
    // Check if we have recorded content before setting ending state
    const hasRecordedContent = this.hasRecording || (this.recordedBlobs && this.recordedBlobs.length > 0);
    console.log('Checking for recording content:', hasRecordedContent, 'blobs:', this.recordedBlobs?.length || 0);
    
    this.setState({ 
      flagEnding: true, 
      ringtone: false, 
      seconds: 0, 
      flagMic: true, 
      flagCamera: false, 
      flagMinimize: false, 
      flagShareScreen: false, 
      time: { h: '00', m: '00', s: '00' }, 
      descAlertCall: 0
    }, () => {
      // Use callback to ensure state is updated properly
      setTimeout(() => {
        if (hasRecordedContent) {
          console.log('Showing save recording dialog');
          this.setState({ 
            showSaveRecording: true,
            flagEnding: false, 
            flagCalling: false, 
            flagStartCall: false, 
            isStarted: false
          });
        } else {
          this.openCallRating(true);
          this.setState({ 
            flagEnding: false, 
            flagCalling: false, 
            flagStartCall: false, 
            isStarted: false 
          });
        }
      }, 2000);
    });
  }

  // Kết thục cuộc gọi
  onClickStopCall() {
    const params = {
      group_id: rxaget(this.callObj, 'group_id', ''),
      uin: this.userid,
      call_id: rxaget(this.callObj, 'call_id', ''),
    }
    this.setState({ ringtone: false, flagStartCall: false, isStarted: false, flagCalling: false }, () => {

      rxio.stopCall(params, (data) => { })
      try {
        if (!this.state.flagStartCall) {
          // const receiverUin = global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== this.userid.toString()))[0]

          let paramsupdate = {
            group_id: rxaget(this.callObj, 'group_id', ''),
            message_id: rxaget(this.callObj, 'message_id', ''),
            message: '',
            status: 2
          }
          rxio.updateMessage(paramsupdate, (dataMsg1) => {
          })

          paramsupdate['status'] = 3
          rxio.updateMessage(paramsupdate, (dataMsg2) => { })

          rxio.socket.emit('event', {
            group_id: rxaget(this.callObj, 'group_id', ''),
            sender_uin: this.userid,
            type: 9
          }, (data1) => { })
          rxio.socket.emit('event', {
            group_id: rxaget(this.callObj, 'group_id', ''),
            sender_uin: this.userid,
            type: 10
          }, (data1) => { })
        }
      } catch (e) { }

      this.stopStream()

      try {
        if (this.type === 'callfunc') {
          this.props.stopCall()
        }
      } catch (e) {
        console.log(e)
      }
    })
  }

  // Count time
  startTimer() {
    this.stopTimeoutCounter()
    setTimeout(() => {
      if (this.state.seconds === 0) {
        this.timer = setInterval(() => { this.countUp() }, 1000)
      }
    }, 1000)
  }

  countUp() {
    let seconds = this.state.seconds + 1;
    this.setState({
      time: secondsToTime(seconds),
      seconds: seconds,
    })
  }

  startTimeoutCounter() {
    setTimeout(() => {
      if (this.secondsCounter === 0) {
        this.timeoutCounter = setInterval(() => {
          this.secondsCounter += 1

          if (this.secondsCounter > 30) {
            this.onClickStopCall()
          }
        }, 1000)
      }
    }, 1000)
  }

  stopTimeoutCounter() {
    try {
      clearInterval(this.timeoutCounter)
      this.timeoutCounter = null
    } catch (e) {
      console.log(e)
    }

    this.secondsCounter = 0
  }

  getAvatar(e, user) {
    if (user.profile_url) {
      e.target.src = global.rxu.config.get_static + user.profile_url
    } else {
      e.target.src = './images/default/static/avadefault.svg'
    }
  }

  // Fuction Handle Stream
  async setLocalStream(mediaConstraints, type) {
    let stream
    try {
      navigator.permissions.query({ name: 'microphone' }).then((permissionObj) => {
        if (permissionObj.state === 'denied') {
          alert('This app don\'t currently have permission to access your microphone. Allow this app to access your microphone.')
        }
      }).catch((error) => { })

      navigator.permissions.query({ name: 'camera' }).then((permissionObj) => {
        if (permissionObj.state === 'denied') {
          alert('This app don\'t currently have permission to access your camera. Allow this app to access your camera.')
        }
      }).catch((error) => { })

      if (type === 1) {
        mediaConstraints['video'] = false
      } else {
        mediaConstraints['video'] = true
      }

      stream = await navigator.mediaDevices.getUserMedia(mediaConstraints)
    } catch (error) {
      console.error('Could not get user media', error)
    }

    try {
      this.localStream = stream
      this.localVideoComponent.srcObject = stream
      this.localAudioComponent.srcObject = stream
    } catch (e) { }
  }

  addLocalTracks(rtcPeerConnection) {
    try {
      if (this.localStream) {
        this.localStream.getTracks().forEach((track) => {
          rtcPeerConnection.addTrack(track, this.localStream)
        })
      }
    } catch (e) { }
  }

  async createOffer(rtcPeerConnection) {
    let sessionDescription
    try {
      sessionDescription = await rtcPeerConnection.createOffer()
      rtcPeerConnection.setLocalDescription(sessionDescription)
    } catch (error) {
      console.error(error)
    }

    let sender_uin = this.userid.toString()
    rxio.sendIceSdp({
      group_id: rxaget(this.callObj, 'group_id', ''),
      call_id: rxaget(this.callObj, 'call_id', ''),
      sender_uin: sender_uin,
      receiver_uin: global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== sender_uin))[0],
      type: 1,
      sdp: sessionDescription.sdp
    })
  }

  async createAnswer(rtcPeerConnection) {
    let sessionDescription
    try {
      sessionDescription = await rtcPeerConnection.createAnswer()
      rtcPeerConnection.setLocalDescription(sessionDescription)
    } catch (error) {
      console.error(error)
    }

    let sender_uin = this.userid.toString()
    rxio.sendIceSdp({
      group_id: rxaget(this.callObj, 'group_id', ''),
      call_id: rxaget(this.callObj, 'call_id', ''),
      sender_uin: sender_uin,
      receiver_uin: global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== sender_uin))[0],
      type: 2,
      sdp: sessionDescription.sdp
    })

    rxio.socket.emit('call_event', {
      group_id: rxaget(this.callObj, 'group_id', ''),
      call_id: rxaget(this.callObj, 'call_id', ''),
      event: 2
    }, (data) => { })
  }

  setRemoteStream(event) {
    try {
      if (this.remoteVideoComponent && event.streams && event.streams[0]) {
        this.remoteVideoComponent.srcObject = event.streams[0];
        this.remoteStream = event.streams[0]; // Fix: use consistent reference
        
        // If we're recording, check if we need to restart with the new stream
        if (this.state.isRecording && this.mediaRecorder) {
          console.log('Remote stream updated while recording, checking if restart needed');
          
          // Get track ID from new stream to compare
          const newVideoTrack = event.streams[0].getVideoTracks()[0];
          if (newVideoTrack && this.currentVideoTrackId !== newVideoTrack.id) {
            console.log('New remote track detected during recording, restarting recorder');
            this.currentVideoTrackId = newVideoTrack.id;
            this.handleStreamChange();
          }
        }
      }
    } catch (e) {
      console.error('Error in setRemoteStream:', e);
    }
  }

  sendConnected(event) {
    if (this.rtcPeerConnection && this.rtcPeerConnection.connectionState === 'connected') {
      let sender_uin = this.userid.toString()
      rxio.socket.emit('event', {
        group_id: rxaget(this.callObj, 'group_id', ''),
        sender_uin: Number(sender_uin),
        receiver_uin: global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== sender_uin))[0],
        type: 11
      }, (data1) => { })

      rxio.socket.emit('call_event', {
        group_id: rxaget(this.callObj, 'group_id', ''),
        call_id: rxaget(this.callObj, 'call_id', ''),
        event: 2
      }, (data) => { })
    }

    if (this.rtcPeerConnection && this.rtcPeerConnection.connectionState === 'failed' && flagCall < 5) {
      flagCall += 1
      this.rtcPeerConnection.restartIce()
    }
  }

  sendIceCandidate(event) {
    if (event.candidate) {
      let sender_uin = this.userid.toString()
      rxio.sendIceCandidate({
        call_id: rxaget(this.callObj, 'call_id', ''),
        group_id: rxaget(this.callObj, 'group_id', ''),
        receiver_uin: global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== sender_uin))[0],
        sdp_mline_index: event.candidate.sdpMLineIndex,
        sender_uin: sender_uin,
        candidate: event.candidate.candidate
      })
    }
  }

  changeFlagMic() {
    let flagMic = this.state.flagMic
    this.setState({ flagMic: !flagMic }, () => {
      try {
        this.localStream.getAudioTracks()[0].enabled = !flagMic
      } catch (e) { }
    })
  }

  changeFlagCamera() {
    let flagCamera = this.state.flagCamera
    this.setState({ flagCamera: !flagCamera }, () => {
      if (this.state.flagStartCall && this.callObj && this.callObj.media_type === 1) {
        try {
          const receiverUin = global.rxu.array(rxaget(this.callObj, 'callee_uins', [])).filter(ele => (ele !== this.userid.toString()))[0]
          if (flagCamera) {
            rxio.socket.emit('event', {
              group_id: rxaget(this.callObj, 'group_id', ''),
              sender_uin: this.userid,
              receiver_uin: Number(receiverUin),
              type: 6
            }, (data1) => { })
          } else {
            rxio.socket.emit('event', {
              group_id: rxaget(this.callObj, 'group_id', ''),
              sender_uin: this.userid,
              receiver_uin: Number(receiverUin),
              type: 5
            }, (data1) => { })
          }
        } catch (e) { }
      }
    })
  }

  onClickFullScreen() {
    try {
      if (this.state.flagStartCall && this.callObj && this.callObj.media_type === 2) {
        let elem = document.getElementById("remote-video");
        if (elem.requestFullscreen) {
          elem.requestFullscreen()
        } else if (elem.webkitRequestFullscreen) { /* Safari */
          elem.webkitRequestFullscreen()
        } else if (elem.msRequestFullscreen) { /* IE11 */
          elem.msRequestFullscreen()
        }
      }
    } catch (e) { }
  }

  onClickShareScreen() {
    let flagShareScreen = this.state.flagShareScreen
    if (this.state.flagStartCall && this.callObj && this.callObj.media_type === 2) {
      if (!flagShareScreen) {
        this.setState({ flagShareScreen: true }, () => {
          this.shareScreen()
        })
      } else {
        // Stop Share Screen
        this.setState({ flagShareScreen: false }, () => {
          try {
            if (this.shareScreenStream) {
              const screenTrack = this.shareScreenStream.getVideoTracks()[0]
              if (screenTrack) {
                screenTrack.stop()
              }
            }
          } catch (e1) { }
          try {
            if (this.localStream) {
              this.localStream.getTracks().forEach((newTrack) => {
                this.replaceTrack(newTrack)
              })
            }
          } catch (e) {
            console.log(e)
          }
        })
      }
    }
  }

  // Handle recording during stream changes (like screen sharing)
  handleStreamChange() {
    // If we're currently recording, we need to restart the recording with the new stream
    if (this.state.isRecording && this.mediaRecorder) {
      console.log('Stream changed while recording, restarting recorder');
      
      // Keep the current recorded data
      const currentBlobs = [...this.recordedBlobs];
      
      // Stop the current recorder
      try {
        if (this.mediaRecorder.state !== 'inactive') {
          this.mediaRecorder.stop();
        }
      } catch (e) {
        console.error('Error stopping recorder during stream change', e);
      }
      
      // Force clear the existing MediaRecorder
      this.mediaRecorder = null;
      
      // Increase wait time to allow the stream to fully stabilize
      setTimeout(() => {
        // Make sure we have a valid remote video stream before restarting
        if (!this.remoteVideoComponent || !this.remoteVideoComponent.srcObject) {
          console.error('No valid remote stream available after switch');
          this.setState({ isRecording: false });
          alert('Recording stopped: Stream not available after source change');
          return;
        }
        
        // Wait a moment before restarting to ensure stream is fully stable
        setTimeout(() => {
          try {
            // Force clear the existing blobs array to avoid duplication
            const savedBlobs = [...currentBlobs];
            this.recordedBlobs = [];
            
            // Create a completely new MediaRecorder with fresh stream
            this.startRecording(true); // true = continuation mode
            
            // After starting, now merge the previous recording chunks
            this.recordedBlobs = [...savedBlobs, ...this.recordedBlobs];
            console.log('Recording restarted with', savedBlobs.length, 'previous chunks');
          } catch (e) {
            console.error('Failed to restart recording after stream change', e);
            this.setState({ isRecording: false });
            alert('Recording stopped: Could not continue recording after stream change');
          }
        }, 500);
      }, 1500);
    }
  }

  async shareScreen() {
    try {
      // Store current recording state
      const wasRecording = this.state.isRecording;
      
      // If recording, stop it properly before changing tracks
      if (wasRecording) {
        console.log('Temporarily stopping recording before screen sharing');
        this.stopRecording();
      }
      
      const mediaStream = await this.getLocalScreenCaptureStream();

      if (mediaStream) {
        this.shareScreenStream = mediaStream

        const screenTrack = mediaStream.getVideoTracks()[0];

        if (screenTrack) {
          console.log('Replacing camera track with screen track:', {
            id: screenTrack.id,
            label: screenTrack.label
          });
          
          // Replace the track in the peer connection
          this.replaceTrack(screenTrack);
          
          // Wait for the track replacement to fully propagate to the remote side
          setTimeout(() => {
            // Only restart recording if it was active before
            if (wasRecording) {
              console.log('Restarting recording after screen sharing started');
              this.startRecording(true); // true = continuation mode
            }
          }, 1000);
          
          // Listen for the end of screen sharing
          screenTrack.onended = () => {
            console.log('Screen sharing ended by user or system');
            this.setState({ flagShareScreen: false });
            
            // Store recording state again
            const wasStillRecording = this.state.isRecording;
            
            // Stop recording temporarily if active
            if (wasStillRecording) {
              console.log('Temporarily stopping recording after screen sharing ended');
              this.stopRecording();
            }
            
            // Revert to camera when screen sharing ends
            if (this.localStream) {
              const videoTrack = this.localStream.getVideoTracks()[0];
              if (videoTrack) {
                console.log('Reverting to camera track:', {
                  id: videoTrack.id,
                  label: videoTrack.label
                });
                
                // Replace the track
                this.replaceTrack(videoTrack);
                
                // Wait for track replacement to propagate
                setTimeout(() => {
                  // Restart recording if it was active
                  if (wasStillRecording) {
                    console.log('Restarting recording after reverting to camera');
                    this.startRecording(true); // true = continuation mode
                  }
                }, 1000);
              }
            }
          };
        } else {
          console.error('No video track found in screen capture stream');
          this.setState({ flagShareScreen: false });
          
          // If recording was stopped, restart it
          if (wasRecording) {
            setTimeout(() => this.startRecording(true), 500);
          }
        }
      } else {
        console.warn('Failed to get screen capture stream');
        this.setState({ flagShareScreen: false });
        
        // If recording was stopped, restart it
        if (wasRecording) {
          setTimeout(() => this.startRecording(true), 500);
        }
      }
    } catch (e) {
      console.error('Error during screen sharing:', e);
      this.setState({ flagShareScreen: false });
      
      // Restart recording if it was active before the error
      if (this.state.isRecording === false && this.hasRecording) {
        setTimeout(() => this.startRecording(true), 500);
      }
    }
  }

  async getLocalScreenCaptureStream() {
    try {
      // Set to 1080p resolution
      let width = 1280;
      let height = 720;
      
      //if (this.localStream && this.localStream.getVideoTracks().length > 0) {
      //  const videoTrack = this.localStream.getVideoTracks()[0];
      //  const settings = videoTrack.getSettings();
      //  if (settings.width && settings.height) {
      //    width = settings.width;
      //    height = settings.height;
      //  }
      //}
      
      const constraints = { 
        video: { 
          cursor: 'always',
          width: { ideal: 1280 },
          height: { ideal: 720 },
          frameRate: { ideal: 60, max: 60 }
        }, 
        audio: false 
      };
      
      const screenCaptureStream = await navigator.mediaDevices.getDisplayMedia(constraints);

      return screenCaptureStream;
    } catch (error) {
      if (error.message && error.message.indexOf('Permission denied by system') !== -1) {
        alert('Trình duyệt này không có quyền "Screen Share". Vui lòng vào cài đặt hệ thống và cho phép quyền "Share Screen" trên trình duyệt này')
      }
    }
  }

  replaceTrack(newTrack) {
    try {
      const sender = this.rtcPeerConnection.getSenders().find(sender =>
        sender.track.kind === newTrack.kind
      );

      if (!sender) {
        console.warn('failed to find sender');

        return;
      }

      sender.replaceTrack(newTrack);
    } catch (e) { }
  }

  onClickMinimizeCall() {
    let flagMinimize = this.state.flagMinimize
    this.setState({
      flagMinimize: !flagMinimize
    })
  }

  mouseOver(e) {
    // let flagMinimize = this.state.flagMinimize
    // if (flagMinimize) {
    //   console.log('mouseOver')
    //   this.setState({
    //     flagMouseOver: true
    //   })  
    // }

  }

  mouseOut(e) {
    let flagMinimize = this.state.flagMinimize
    console.log(e.relatedTarget)
    console.log(e.currentTarget)
    // if (flagMinimize) {
    //   this.setState({
    //     flagMouseOver: false
    //   })  
    // }

  }

  gotDevices(deviceInfos) {
    console.log('DeviceInfos: %v ------', deviceInfos)
    let audioinput = []
    let audiooutput = []
    let videoinput = []
    let audioinputTmp = ''
    let audiooutputTmp = ''
    let videoinputTmp = ''
    let audioinputDefault = ''
    let audiooutputDefault = ''
    let videoinputDefault = ''
    for (let i = 0; i !== deviceInfos.length; ++i) {
      const deviceInfo = deviceInfos[i];
      let objInfo = {}
      objInfo['value'] = deviceInfo.deviceId
      if (deviceInfo.kind === 'audioinput') {
        if (deviceInfo.deviceId === 'default' && deviceInfo.label) {
          audioinputTmp = rxaget(deviceInfo, 'label', '').replace('Default - ', '')
        } else {
          objInfo['text'] = deviceInfo.label || `microphone ${audioinput.length + 1}`
          if (deviceInfo.label === audioinputTmp) {
            audioinputDefault = deviceInfo.deviceId
          }
          audioinput.push(objInfo)
        }
      } else if (deviceInfo.kind === 'audiooutput') {
        if (deviceInfo.deviceId === 'default' && deviceInfo.label) {
          audiooutputTmp = rxaget(deviceInfo, 'label', '').replace('Default - ', '')
        } else {
          objInfo['text'] = deviceInfo.label || `speaker ${audiooutput.length + 1}`
          if (deviceInfo.label === audiooutputTmp) {
            audiooutputDefault = deviceInfo.deviceId
          }
          audiooutput.push(objInfo)
        }

      } else if (deviceInfo.kind === 'videoinput') {
        if (deviceInfo.deviceId === 'default' && deviceInfo.label) {
          videoinputTmp = rxaget(deviceInfo, 'label', '').replace('Default - ', '')
        } else {
          objInfo['text'] = deviceInfo.label || `camera ${videoinput.length + 1}`
          if (deviceInfo.label === videoinputTmp) {
            videoinputDefault = deviceInfo.deviceId
          }
          videoinput.push(objInfo)
        }

      } else {
        console.log('Some other kind of source/device: ', deviceInfo)
      }
    }
    if (!audioinputTmp && audioinput.length > 0) {
      audioinputDefault = audioinput[0]['value']
    }
    if (!audiooutputTmp && audiooutput.length > 0) {
      audiooutputDefault = audiooutput[0]['value']
    }
    if (!videoinputTmp && videoinput.length > 0) {
      videoinputDefault = videoinput[0]['value']
    }
    this.setState({
      audioinput: audioinput,
      audiooutput: audiooutput,
      videoinput: videoinput,
      audioinputDefault: audioinputDefault,
      audiooutputDefault: audiooutputDefault,
      videoinputDefault: videoinputDefault
    })
  }
  attachSinkId(element, sinkId, type) {
    console.log(element)
    if (typeof element.sinkId !== 'undefined') {
      element.setSinkId(sinkId)
        .then(() => {
          console.log(`Success, audio output device attached: ${sinkId} to element with ${element.title} as source.`);

          if (type === 'audiooutput') {
            this.setState({
              audiooutputDefault: sinkId
            })
          }

        })
        .catch(error => {
          let errorMessage = error;
          if (error.name === 'SecurityError') {
            errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
          }
          console.error(errorMessage);
        });
    } else {
      console.warn('Browser does not support output device selection.');
    }
  }
  changeDeviceAudioInput(e) {
    let audioSource = e.target.value
    if (mediaConstraints.audio) {
      mediaConstraints.audio = { deviceId: audioSource ? { exact: audioSource } : undefined }
    }
    this.setState({
      audioinputDefault: audioSource
    }, () => {
      this.changeDeviceInput(mediaConstraints, 'audio')
    })
    // let constraints = {
    //   audio: {deviceId: audioSource ? {exact: audioSource} : undefined},
    //   video: {deviceId: videoSource ? {exact: videoSource} : undefined}
    // };
    // navigator.mediaDevices.getUserMedia(constraints).then(gotStream).then(gotDevices).catch(handleError);
  }

  changeDeviceAudioOutput(e) {
    this.attachSinkId(this.remoteAudioComponent, e.target.value, 'audiooutput')
  }

  changeDeviceCamera(e) {
    console.log('changeDeviceCamera')
    console.log(e.target.value)
  }

  // Replace Track
  changeDeviceInput(constraints, type) {
    try {
      try {
        if (this.localStream) {
          const tracks = this.localStream.getTracks()
          tracks.forEach(function (track) { track.stop() })
          this.localStream = null
        }
      } catch (e) { }
      navigator.mediaDevices.getUserMedia(constraints)
        .then((stream) => {
          try {
            let videoTrack = stream.getVideoTracks()[0]
            let audioTrack = stream.getAudioTracks()[0]
            if (videoTrack) {
              let sender = this.rtcPeerConnection.getSenders().find(function (s) {
                return s.track.kind == videoTrack.kind
              })
              sender.replaceTrack(videoTrack);
              console.log('found sender:', sender);
            }
            if (audioTrack) {
              let sender2 = this.rtcPeerConnection.getSenders().find(function (s) {
                return s.track.kind == audioTrack.kind
              })
              sender2.replaceTrack(audioTrack);
              console.log('found sender2:', sender2);
            }

            this.localStream = stream;
            if (type === 'audio') {
              this.localAudioComponent.srcObject = stream
            } else {
              this.localVideoComponent.srcObject = stream
            }
          } catch (e) {
            console.log(e)
          }
        })
    } catch (e2) { }
  }

  handleClickOutside(e) {
    if (e.target && e.target.className && this.state.flagShowSetting) {
      if (['device-setting', 'device-setting-label', 'device-setting-select'].indexOf(e.target.className) === -1) {
        this.setState({
          flagShowSetting: false
        })
      }
    }
  }

  showDeviceSetting() {
    let flagShowSetting = this.state.flagShowSetting
    this.setState({
      flagShowSetting: !flagShowSetting
    })
  }

  onClickCloseSetting() {
    this.setState({
      flagShowSetting: false
    })
  }

  previewGetStatsResult(peer, result) {
    // if(STOP_GETSTATS) {
    //     result.nomore();
    //     return;
    // }

    if (result.connectionType.remote.candidateType.indexOf('relayed') !== -1) {
      result.connectionType.remote.candidateType = 'TURN';
    }
    else {
      result.connectionType.remote.candidateType = 'STUN';
    }


    if (result.connectionType.local.candidateType.indexOf('relayed') !== -1) {
      result.connectionType.local.candidateType = 'TURN';
    }
    else {
      result.connectionType.local.candidateType = 'STUN';
    }


    let remote = {
      remoteIceType: result.connectionType.remote.candidateType,
      externalIPAddressRemote: result.connectionType.remote.ipAddress.join(', '),
      remoteTransport: result.connectionType.remote.transport.join(', '),
      encryptedAs: result.encryption,
      videoResolutionsForReceivers: result.resolutions.recv.width + 'x' + result.resolutions.recv.height,
      totalDataForReceivers: this.bytesToSize(result.audio.bytesReceived + result.video.bytesReceived),
      codecsRecv: result.audio.recv.codecs.concat(result.video.recv.codecs).join(', '),
      bandwidthSpeed: this.bytesToSize(result.bandwidth.speed),
      framerateMean: this.bytesToSize(result.video.send.framerateMean),
      bitrateMean: this.bytesToSize(result.video.send.bitrateMean),
      audiolatency: result.audio.latency + 'ms',
      videolatency: result.video.latency + 'ms',
      audiopacketsLost: result.audio.packetsLost,
      videopacketsLost: result.video.packetsLost

    }

    let local = {
      localIceType: result.connectionType.local.candidateType,
      externalIPAddressLocal: result.connectionType.local.ipAddress.join(', '),
      localTransport: result.connectionType.local.transport.join(', '),
      encryptedAs: result.encryption,
      videoResolutionsForSenders: result.resolutions.send.width + 'x' + result.resolutions.send.height,
      totalDataForSenders: this.bytesToSize(result.audio.bytesSent + result.video.bytesSent),
      codecsSend: result.audio.send.codecs.concat(result.video.send.codecs).join(', '),
      bandwidthSpeed: this.bytesToSize(result.bandwidth.speed),
      framerateMean: this.bytesToSize(result.video.send.framerateMean),
      bitrateMean: this.bytesToSize(result.video.send.bitrateMean),
      audiolatency: result.audio.latency + 'ms',
      videolatency: result.video.latency + 'ms',
      audiopacketsLost: result.audio.packetsLost,
      videopacketsLost: result.video.packetsLost
    }

    this.setState({ localStream: local, remoteStream: remote })

  }

  bytesToSize(bytes) {
    var k = 1000;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes <= 0) {
      return '0 Bytes';
    }
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(k)), 10);

    if (!sizes[i]) {
      return '0 Bytes';
    }

    return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
  }

  showCallTrouble() {

    // Your web app's Firebase configuration
    const firebaseConfig = {
      apiKey: "AIzaSyCmlqZOK-gNXW-b8lIX_gNJCXC86nzj7uw",
      authDomain: "reportcall-a562b.firebaseapp.com",
      databaseURL: "https://reportcall-a562b-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "reportcall-a562b",
      storageBucket: "reportcall-a562b.appspot.com",
      messagingSenderId: "760021342191",
      appId: "1:760021342191:web:8ee67eacb83d514f0c881a"
    }

    let { localStream, remoteStream } = this.state

    this.setState({ showCallTrouble: !this.state.showCallTrouble }, () => {
      if (this.state.flagStartCall) {
        const app = initializeApp(firebaseConfig)

        let postId = Math.floor(Date.now() / 1000)

        const database = getDatabase(app)

        set(ref(database, 'reports/' + postId), {
          localStream: localStream,
          remoteStream: remoteStream,
          callee_uin: this.userid.toString(),
          call_id: rxaget(this.callObj, 'call_id', ''),
          group_id: rxaget(this.callObj, 'group_id', ''),
          call_type: rxaget(this.callObj, 'call_type', ''),
          callee_uins: rxaget(this.callObj, 'callee_uins', ''),
          media_type: rxaget(this.callObj, 'media_type', ''),
        }).then(() => {
          // Data saved successfully!
        }).catch((error) => {
          console.error(error);
        })
      }
      this.flagSendFirebase = false;

    })

  }

  openCallRating(isOpen) {
    this.setState({ open_call_rating: isOpen })
  }

  onClickRecord() {
    if (!this.state.isRecording) {
      console.log('Starting recording')
      this.startRecording()
    } else {
      console.log('Stopping recording')
      this.stopRecording()
      
      // Ensure we mark this recording for saving
      if (this.recordedBlobs && this.recordedBlobs.length > 0) {
        this.hasRecording = true
        console.log('Recording saved with blobs:', this.recordedBlobs.length)
      }
    }
  }

  startRecording(isContinuation = false) {
    if (!this.remoteVideoComponent) {
      console.error('No remote video component available')
      return
    }
    
    if (!this.remoteVideoComponent.srcObject) {
      console.error('Remote video component has no stream source')
      return
    }
    
    try {
      // Get a direct reference to the current stream
      const originalStream = this.remoteVideoComponent.srcObject
      
      // Verify we have video tracks before proceeding
      const videoTracks = originalStream.getVideoTracks()
      if (!videoTracks || videoTracks.length === 0) {
        console.error('No video tracks in stream to record')
        alert('Cannot start recording: No video track found in the stream')
        return
      }
      
      // Get the audio tracks
      const audioTracks = originalStream.getAudioTracks()
      
      // Create a new stream with the tracks to ensure proper initialization
      const stream = new MediaStream()
      videoTracks.forEach(track => stream.addTrack(track))
      if (audioTracks && audioTracks.length > 0) {
        audioTracks.forEach(track => stream.addTrack(track))
      }
      
      console.log('Starting recording with video track:', {
        id: videoTracks[0].id,
        label: videoTracks[0].label,
        settings: videoTracks[0].getSettings()
      })
      
      // Only reset blobs if this is not a continuation from a stream change
      if (!isContinuation) {
        this.recordedBlobs = []
        this.hasRecording = false
      }
      
      // Check for supported MIME types in order of preference
      const mimeTypes = [
        'video/webm;codecs=vp8,opus',
        'video/webm;codecs=vp9,opus',
        'video/webm;codecs=vp8',
        'video/webm'
      ];
      
      let options = null;
      let selectedMimeType = null;
      
      // Find first supported MIME type
      for (const mimeType of mimeTypes) {
        if (MediaRecorder.isTypeSupported(mimeType)) {
          selectedMimeType = mimeType;
          options = {
            mimeType,
            videoBitsPerSecond: 2500000,
            audioBitsPerSecond: 128000
          };
          console.log(`Using supported MIME type: ${mimeType}`);
          break;
        }
      }
      
      if (!options) {
        console.warn('None of the preferred MIME types are supported, using default');
        options = {
          videoBitsPerSecond: 2500000,
          audioBitsPerSecond: 128000
        };
      }
      
      // Store selected MIME type for later use when saving
      this.selectedMimeType = selectedMimeType || 'video/webm';
      
      try {
        // Create a new MediaRecorder instance with supported options
        this.mediaRecorder = new MediaRecorder(stream, options);
        console.log('Created MediaRecorder with state:', this.mediaRecorder.state, 'using options:', options);
      } catch (e) {
        console.error(`Exception while creating MediaRecorder:`, e);
        // Try with a more basic configuration
        try {
          console.warn('Falling back to basic MediaRecorder');
          this.mediaRecorder = new MediaRecorder(stream);
          this.selectedMimeType = 'video/webm';
        } catch (fallbackError) {
          console.error('Failed to create MediaRecorder even with fallback:', fallbackError);
          if (!isContinuation) {
            alert('Cannot start recording: Your browser may not support recording this stream');
          }
          return;
        }
      }
      
      this.mediaRecorder.onstop = (event) => {
        console.log('Recorder stopped: ', event);
        // Ensure we mark this recording for saving when stopped
        if (this.recordedBlobs && this.recordedBlobs.length > 0) {
          this.hasRecording = true;
          console.log('Recording completed with', this.recordedBlobs.length, 'blobs');
        }
      };
      
      this.mediaRecorder.onerror = (event) => {
        console.error('MediaRecorder error:', event);
      };
      
      this.mediaRecorder.ondataavailable = (event) => {
        if (event.data && event.data.size > 0) {
          // Make sure we have properly sized chunks
          this.recordedBlobs.push(event.data);
          console.log(`Data available: added chunk of ${event.data.size} bytes, total chunks: ${this.recordedBlobs.length}`);
        }
      };
      
      // Monitor stream changes during recording
      this.attachStreamChangeListeners(stream);
      
      // Use smaller timeslices for more reliable chunks
      // This ensures more frequent metadata updates in the WebM container
      this.mediaRecorder.start(250);
      console.log('MediaRecorder started with timeslice=250ms, state:', this.mediaRecorder.state);
      
      if (!isContinuation) {
        this.setState({ isRecording: true });
      }
    } catch (error) {
      console.error('Error starting recording:', error);
      if (!isContinuation) {
        alert('Failed to start recording: ' + error.message);
        this.setState({ isRecording: false });
      }
    }
  }
  
  // Attach listeners to detect when the stream changes
  attachStreamChangeListeners(stream) {
    if (!stream) return;
    
    // Store current tracks to monitor for changes
    const videoTrack = stream.getVideoTracks()[0];
    this.currentVideoTrackId = videoTrack ? videoTrack.id : null;
    
    console.log('Monitoring video track with ID:', this.currentVideoTrackId);
    
    // Create a function to check for track changes
    const checkForTrackChanges = () => {
      if (!stream || !this.state.isRecording) return;
      
      const currentVideoTrack = stream.getVideoTracks()[0];
      const currentId = currentVideoTrack ? currentVideoTrack.id : null;
      
      if (currentId && this.currentVideoTrackId && currentId !== this.currentVideoTrackId) {
        console.log('Video track changed during recording', {
          from: this.currentVideoTrackId,
          to: currentId
        });
        this.currentVideoTrackId = currentId;
        this.handleStreamChange();
      }
    };
    
    // Set up periodic checks for track changes
    this.trackCheckInterval = setInterval(checkForTrackChanges, 1000); // Increased frequency from 2000ms to 1000ms
  }
  
  // Clean up track change monitoring
  clearStreamChangeListeners() {
    if (this.trackCheckInterval) {
      clearInterval(this.trackCheckInterval);
      this.trackCheckInterval = null;
    }
  }

  stopRecording() {
    if (!this.mediaRecorder || this.mediaRecorder.state === 'inactive') return
    
    try {
      this.clearStreamChangeListeners();
      this.mediaRecorder.stop()
      console.log('Recording stopped')
      this.setState({ isRecording: false })
      
      // Mark that we have a recording to save
      if (this.recordedBlobs && this.recordedBlobs.length > 0) {
        this.hasRecording = true
      }
      // We'll show the save dialog after the call ends in stopStream
    } catch (error) {
      console.error('Error stopping recording:', error)
    }
  }

  saveRecording() {
    try {
        if (!this.recordedBlobs || this.recordedBlobs.length === 0) {
            console.error('No recorded data available to save');
            alert('Error: No recording data found');
            this.setState({ showSaveRecording: false }, () => {
                this.openCallRating(true);
            });
            return;
        }

        console.log('Saving recording with', this.recordedBlobs.length, 'chunks');

        // Filter out any zero-sized or invalid blobs
        const validBlobs = this.recordedBlobs.filter(blob => blob && blob.size > 1000);

        if (validBlobs.length === 0) {
            console.error('No valid data found in recording');
            alert('Error: Recording contains no valid data');
            this.setState({ showSaveRecording: false }, () => {
                this.openCallRating(true);
            });
            return;
        }

        console.log('Valid blobs for saving:', validBlobs.map(b => b.size).join(', '));
        
        // Ensure proper EBML initialization - add a small inert header blob if needed
        // This helps fix issues with the first recording after permission grants
        let blobsToUse = [...validBlobs];
        
        // Create a properly formatted WebM blob
        const blob = new Blob(blobsToUse, { 
            type: 'video/webm;codecs=vp8,opus' 
        });

        console.log(`Created final blob of size ${blob.size} bytes`);

        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;

        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        const calleeName = (this.calleeUser && this.calleeUser.full_name) ? this.calleeUser.full_name : 'recording';
        a.download = `call-with-${calleeName}-${timestamp}.webm`;

        document.body.appendChild(a);
        a.click();

        // Wait for the download to process before cleanup
        setTimeout(() => {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
            this.recordedBlobs = [];
            this.hasRecording = false;
            this.setState({ showSaveRecording: false }, () => {
                this.openCallRating(true);
            });
        }, 500); // Increased timeout to ensure download completes

    } catch (error) {
        console.error('Error saving recording:', error);
        alert('Failed to save recording: ' + error.message);
        this.recordedBlobs = [];
        this.hasRecording = false;
        this.setState({ showSaveRecording: false }, () => {
            this.openCallRating(true);
        });
    }
  }

  discardRecording() {
    // Discard the recording
    this.recordedBlobs = []
    this.hasRecording = false
    this.setState({ showSaveRecording: false }, () => {
      this.openCallRating(true)
    })
  }

  render() {
    return this.renderComponent()
  }
}

const mapStateToProps = (state, ownProps) => ({
  themeValue: state.themeValue,
  langValue: state.langValue,
  rxgroup: state.rxgroup,
  user: state.user,
  netaauth: state.netaauth,
  netaCallHistory: state.netaCallHistory,
  netaCall: state.netaCall
})

const mapDispatchToProps = {
  netaCallHistoryUpdate,
  changeStatusTabmore,
  changeGroupFunc
}

const ComponentWrapped = connect(
  mapStateToProps,
  mapDispatchToProps
)(CallComponent_)

export default ComponentWrapped
